<template>
  <div class="h-screen w-full flex bg-white text-black">
    <amio-sidebar :is-deactivated="true" />
    <div class="content-wrapper-x flex flex-row">
      <shadowed-wrapper class="z-420 w-full"
        :class="{ 'lg:w-1/2 px-6 sm:px-10 lg:px-14 py-10 lg:py-16': !isDemoScheduled }">
        <template v-if="isDemoScheduled">
          <div class="bg-background text-center h-full flex flex-col items-center justify-center">
            <p class="text-5xl mb-4">🎉</p>
            <h1 class="mx-0 xs:mx-24 sm:mx-0 text-5xl d-theme-heading-color">See you on the call!</h1>
            <span class="mt-5 xs:mx-32 sm:mx-0 text-xl text-gray-dark">Your meeting has been scheduled</span>
          </div>
        </template>

        <template v-else>
          <p class="text-xs font-bold tracking-widest text-primary">NEXT STEP</p>
          <h1 class="d-theme-heading-color text-4xl sm:text-5xl font-semibold leading-tight mt-3">
            We&apos;ll onboard you personally
          </h1>
          <p class="text-lg leading-relaxed text-gray-dark mt-4">
            Pick a date for a friendly demo and we&apos;ll help you set up Amio the right way from day one.
          </p>

          <div class="rounded-lg p-6 mt-8 bg-soft border border-gray-border">
            <p class="font-semibold text-lg">Why this step matters</p>
            <p class="text-base leading-relaxed text-gray-dark mt-4">
              Teams that start without guidance rarely get the full value from Amio. A short onboarding demo helps us understand your goals, tailor the setup, and get you to value faster.
            </p>
            <ul class="text-base text-gray-dark mt-4 list-none p-0 m-0">
              <li class="flex items-start mb-2">
                <span class="text-primary font-bold mr-3">✓</span>
                <span>Tailored setup for your use case</span>
              </li>
              <li class="flex items-start mb-2">
                <span class="text-primary font-bold mr-3">✓</span>
                <span>Fewer mistakes during the first launch</span>
              </li>
              <li class="flex items-start">
                <span class="text-primary font-bold mr-3">✓</span>
                <span>Faster path to real results</span>
              </li>
            </ul>
          </div>
        </template>
      </shadowed-wrapper>

      <div v-if="!isDemoScheduled" class="bg-background w-full lg:w-1/2 px-6 sm:px-10 lg:px-14 py-10 lg:py-16">
          <div
            class="calendly-inline-widget"
            data-url="https://calendly.com/d/cx28-9ty-f3q/demo?hide_gdpr_banner=1"
            style="min-width:320px;height:100%;"
          ></div>
      </div>
    </div>
  </div>
</template>

<script>
import AmioSidebar from '@/components/AmioSidebar'
import ShadowedWrapper from '@/components/base-components/ShadowedWrapper'
import LOCALE_STORAGE_KEYS from '@/utils/local-storage.keys'

export default {
  components: {
    AmioSidebar,
    ShadowedWrapper
  },
  data() {
    return {
      isDemoScheduled: false
    }
  },
  mounted() {
    this.loadIsDemoScheduledFromStorage()
    window.addEventListener('message', this.handleCalendlyMessage)

    const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')

    if (!existingScript) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      script.async = true
      document.body.appendChild(script)
    } else if (window.Calendly && typeof window.Calendly.initInlineWidgets === 'function') {
      window.Calendly.initInlineWidgets()
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleCalendlyMessage)
  },
  methods: {
    isCalendlyEvent(event) {
      return event.origin === 'https://calendly.com' &&
        typeof event.data?.event === 'string' &&
        event.data.event.startsWith('calendly.')
    },
    loadIsDemoScheduledFromStorage() {
      this.isDemoScheduled = localStorage.getItem(LOCALE_STORAGE_KEYS.IS_DEMO_SCHEDULED) || false
    },
    handleCalendlyMessage(event) {
      if (!this.isCalendlyEvent(event)) return

      const calendlyEvent = event.data?.event
      if (calendlyEvent === 'calendly.event_scheduled') {
        localStorage.setItem(LOCALE_STORAGE_KEYS.IS_DEMO_SCHEDULED, 'true')
        this.isDemoScheduled = true
      }
    }
  }
}
</script>

<style scoped>
.content-wrapper-x {
  padding-left: 100px;
  min-height: 100vh;
  width: 100%;
}
</style>
